import styled from 'styled-components'

export const Article = styled.article`
  ${p => p.theme.mq.upLg} {
    max-width: 80%;
  }
`
